import { render } from "./coverImage.vue?vue&type=template&id=15a54188&scoped=true"
import script from "./coverImage.vue?vue&type=script&lang=js"
export * from "./coverImage.vue?vue&type=script&lang=js"

import "./coverImage.vue?vue&type=style&index=0&id=15a54188&scoped=true&lang=css"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a54188"]])

export default __exports__